import BaseStorageInterface, { DEFAULT_STORAGE_KEY_NAME, StorageType } from "./BaseStorage";


export interface CookieStorageInterface extends BaseStorageInterface {
    numOfDays: number,
    secure: boolean,
    sameSite: string
}

const CookieStorage: CookieStorageInterface = {
    type: StorageType.cookieStorage,
    storageKey: DEFAULT_STORAGE_KEY_NAME,
    secure: false,
    sameSite: "Lax",
    numOfDays:  365,
    setItem(value) {
        const date = new Date();
        date.setTime(date.getTime() + (this.numOfDays * 24 * 60 * 60 * 1000));
        const expires = "expires=" + date.toUTCString();
        let cookieBuilder = this.storageKey + "=" + value + "; " + expires + "; path=/;";

        if (this.sameSite) {
            cookieBuilder += "SameSite="+this.sameSite+";"
        }

        if (this.secure) {
            cookieBuilder += "secure;"
        }

        document.cookie = cookieBuilder;
    },
    getItem() {
        const name = this.storageKey + "=";
        const cDecoded = decodeURIComponent(document.cookie);
        const cArr = cDecoded.split('; ');
        let res = null;
        cArr.forEach(val => {
            if (val.indexOf(name) === 0) {
                res = (val.substring(name.length));
                return;
            }
        })
        return  (res === null) ? null : res;
    },
    removeItem() {
        document.cookie = encodeURIComponent(this.storageKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;"
    }
};

export default CookieStorage;
